import { isEmpty } from "lodash-es";
import isAggregationResponse from "./isAggregationResponse";
const getAggrItems = (aggr, facetKey) => {
    var _a, _b, _c, _d, _e, _f;
    // Il seguente codice funziona se si da per scontato che tutti il livelli di aggregazione abbiano la facetKey come chiave.
    const buckets = ((_a = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _a === void 0 ? void 0 : _a.buckets) ||
        ((_c = (_b = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _b === void 0 ? void 0 : _b[facetKey]) === null || _c === void 0 ? void 0 : _c.buckets) ||
        ((_f = (_e = (_d = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _d === void 0 ? void 0 : _d[facetKey]) === null || _e === void 0 ? void 0 : _e[facetKey]) === null || _f === void 0 ? void 0 : _f.buckets); // nested su attributo di secondo livello. es. "access.userId" (SEECOMM-7701)
    return !isEmpty(buckets) ? buckets : [];
};
const getRange = (aggr, facetKey) => {
    const { range } = aggr[facetKey];
    return !!range ? range.buckets : [];
};
const getDocCountErrorUpperBound = (aggr, facetKey) => {
    var _a, _b, _c, _d, _e, _f;
    const doc_count_error_upper_bound = ((_a = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _a === void 0 ? void 0 : _a.doc_count_error_upper_bound) ||
        ((_c = (_b = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _b === void 0 ? void 0 : _b[facetKey]) === null || _c === void 0 ? void 0 : _c.doc_count_error_upper_bound) ||
        ((_f = (_e = (_d = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _d === void 0 ? void 0 : _d[facetKey]) === null || _e === void 0 ? void 0 : _e[facetKey]) === null || _f === void 0 ? void 0 : _f.doc_count_error_upper_bound); // nested su attributo di secondo livello. es. "access.userId" (SEECOMM-7701)
    return doc_count_error_upper_bound;
};
const getSumOtherDocCount = (aggr, facetKey) => {
    var _a, _b, _c, _d, _e, _f;
    const sum_other_doc_count = ((_a = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _a === void 0 ? void 0 : _a.sum_other_doc_count) ||
        ((_c = (_b = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _b === void 0 ? void 0 : _b[facetKey]) === null || _c === void 0 ? void 0 : _c.sum_other_doc_count) ||
        ((_f = (_e = (_d = aggr === null || aggr === void 0 ? void 0 : aggr[facetKey]) === null || _d === void 0 ? void 0 : _d[facetKey]) === null || _e === void 0 ? void 0 : _e[facetKey]) === null || _f === void 0 ? void 0 : _f.sum_other_doc_count); // nested su attributo di secondo livello. es. "access.userId" (SEECOMM-7701)
    return sum_other_doc_count;
};
const getAggregations = (aggr) => {
    return Object.keys(aggr).map((facetKey) => {
        return {
            id: facetKey,
            items: getAggrItems(aggr, facetKey),
            range: getRange(aggr, facetKey),
            doc_count_error_upper_bound: getDocCountErrorUpperBound(aggr, facetKey),
            sum_other_doc_count: getSumOtherDocCount(aggr, facetKey),
        };
    });
};
const getElasticSrcAggregations = (elasticSrc) => {
    if (isAggregationResponse(elasticSrc)) {
        const aggr = elasticSrc.aggregations;
        if (!isEmpty(aggr)) {
            return getAggregations(aggr);
        }
    }
    return [];
};
export default getElasticSrcAggregations;
